(() => {
  let headerObserver;
  let headerReadyObserver;

  const updateStickyIngredientsOffset = () => {
    const stickyHeader = document.querySelector('.header--sticky');

    if (!stickyHeader) return;

    const rootStyles = getComputedStyle(document.documentElement);
    const gap = parseFloat(rootStyles.getPropertyValue('--gutter-small')) || 0;
    const offset = Math.ceil(stickyHeader.getBoundingClientRect().height + gap);

    document.querySelectorAll('.recipe__ingredients').forEach((ingredients) => {
      ingredients.style.setProperty('--recipe-ingredients-sticky-top', `${offset}px`);
    });
  };

  const initialiseStickyIngredientsOffset = () => {
    const stickyHeader = document.querySelector('.header--sticky');

    if (!stickyHeader) return false;

    headerObserver?.disconnect();
    headerObserver = new ResizeObserver(updateStickyIngredientsOffset);
    headerObserver.observe(stickyHeader);
    headerReadyObserver?.disconnect();
    updateStickyIngredientsOffset();
    return true;
  };

  const waitForStickyHeader = () => {
    if (initialiseStickyIngredientsOffset()) return;

    headerReadyObserver?.disconnect();
    headerReadyObserver = new MutationObserver(() => {
      initialiseStickyIngredientsOffset();
    });
    headerReadyObserver.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['class'],
      childList: true,
      subtree: true
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', waitForStickyHeader, { once: true });
  } else {
    waitForStickyHeader();
  }

  window.addEventListener('load', waitForStickyHeader, { once: true });
  window.addEventListener('resize', updateStickyIngredientsOffset, { passive: true });
  document.addEventListener('shopify:section:load', waitForStickyHeader);
})();
